import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=08188e17&scoped=true"
import script from "./registerDialog.vue?vue&type=script&lang=js"
export * from "./registerDialog.vue?vue&type=script&lang=js"
import style0 from "./registerDialog.vue?vue&type=style&index=0&id=08188e17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08188e17",
  null
  
)

export default component.exports